/**
 * Industries data for San Gabriel Solutions
 * Demonstrates relevance across multiple business sectors
 */

export const industries = [
  {
    id: 'professional-services',
    name: 'Professional Services',
    description: 'Strategic marketing for law firms, consulting, accounting, and professional practices seeking to build authority and generate qualified leads.',
    icon: 'BriefcaseIcon',
    challenges: [
      'Building trust and credibility in competitive markets',
      'Differentiating expertise and service offerings',
      'Generating qualified leads and referrals',
      'Establishing thought leadership positioning'
    ],
    solutions: [
      'Thought leadership content and positioning strategies',
      'Professional brand development and messaging',
      'Content marketing and SEO for visibility',
      'Strategic networking and partnership development'
    ]
  },
  {
    id: 'real-estate-development',
    name: 'Real Estate and Development',
    description: 'Marketing strategies for real estate firms, developers, and property management companies looking to attract buyers, tenants, and investors.',
    icon: 'BuildingOfficeIcon',
    challenges: [
      'Standing out in saturated local markets',
      'Reaching qualified buyers and investors',
      'Building brand recognition and trust',
      'Showcasing properties effectively across channels'
    ],
    solutions: [
      'Integrated digital and traditional advertising campaigns',
      'Property showcase and virtual tour strategies',
      'Targeted audience segmentation and outreach',
      'Brand positioning for premium developments'
    ]
  },
  {
    id: 'healthcare-wellness',
    name: 'Healthcare and Wellness',
    description: 'Compliant marketing solutions for healthcare providers, wellness centers, and medical practices focused on patient acquisition and retention.',
    icon: 'HeartIcon',
    challenges: [
      'Navigating healthcare marketing regulations and compliance',
      'Building patient trust and credibility',
      'Communicating complex services clearly',
      'Competing with larger healthcare systems'
    ],
    solutions: [
      'Compliant digital marketing and content strategies',
      'Patient education and engagement programs',
      'Local SEO and reputation management',
      'Brand development emphasizing care and expertise'
    ]
  },
  {
    id: 'retail-consumer-brands',
    name: 'Retail and Consumer Brands',
    description: 'Growth-focused marketing for retail businesses and consumer brands seeking to increase visibility, drive sales, and build customer loyalty.',
    icon: 'ShoppingBagIcon',
    challenges: [
      'Driving consistent foot traffic and online sales',
      'Building brand loyalty in competitive markets',
      'Managing multi-channel marketing effectively',
      'Adapting to changing consumer behaviors'
    ],
    solutions: [
      'Omnichannel marketing and advertising strategies',
      'Customer journey optimization and conversion tactics',
      'Brand storytelling and community building',
      'Data-driven campaign management and optimization'
    ]
  },
  {
    id: 'technology-startups',
    name: 'Technology and Startups',
    description: 'Strategic marketing for tech companies and startups looking to establish market presence, attract users, and scale growth.',
    icon: 'CpuChipIcon',
    challenges: [
      'Explaining complex technology to target audiences',
      'Building brand awareness with limited budgets',
      'Generating leads and user acquisition',
      'Establishing credibility in competitive tech markets'
    ],
    solutions: [
      'Go-to-market strategy and positioning',
      'Growth marketing and user acquisition campaigns',
      'Content marketing and thought leadership',
      'Strategic partnerships and PR initiatives'
    ]
  }
];

export default industries;
